import React from 'react';
import { LeftTop, Title, HB } from './style'
import { Table } from 'antd'
import styled from 'styled-components';

const LeftDiv = styled.div`
  width: calc(50% - 5px);
  background-color: #fff;
  border-radius: 12px;
`;
const Divs = styled.div`
height: 280px;
overflow-y: auto;
`;
export default (props) => {
   
    const columns = [
        {
            title: '质控规则',
            dataIndex: 'examDataFld',
            key: 'examDataFld',
        },
        {
            title: '质控校验结果',
            dataIndex: 'qltctrlChkRslt',
            key: 'qltctrlChkRslt',
        },
        {
            title: '质控等级',
            dataIndex: 'errLv',
            key: 'errLv',
            width: 110,
            render: (text) => {
                const levelMap = {
                    1: '严重问题',
                    2: '一般问题',
                    3: '轻微问题',
                };
                return levelMap[text] || ''; 
            },
        }
    ];

    return (
        <LeftDiv>
            <LeftTop>
                <HB />
                <Title style={{fontSize: '16px'}}>质控结果</Title>
            </LeftTop>
            <Divs>
                 <Table rowKey='examDataFld' scroll={{ y: 220 }} size="small" bordered columns={columns} dataSource={props.qualContList} style={{ marginTop: '10px' }} pagination={false}/>
            </Divs>
           
        </LeftDiv>

    );
};

